import { buildAxiosInstance, buildAxiosWithoutInterceptors, buildMakeUseAxios } from "@root/api/api.tools";

export const axios = buildMakeUseAxios(`${import.meta.env.VITE_SETTING_SERVICE_URL}/notifications`);
export const axiosWithoutInterceptors = buildAxiosWithoutInterceptors(
  `${import.meta.env.VITE_SETTING_SERVICE_URL}/notifications`
);
export const axiosNotificationInstance = buildAxiosInstance(
  `${import.meta.env.VITE_SETTING_SERVICE_URL}/notifications`
);
